/**
 * 점검 관련 타입 정의
 */

/** 현재 활성화된 점검 응답 DTO */
export type ActiveMaintenanceResponse = {
    isMaintenance: boolean;
    seqNo: number | null;
    startDate: string | number[] | null;
    endDate: string | number[] | null;
    msgCode: string | null;
    msgContent: string | null;
};

/** 기본 점검 응답 (점검 없음) */
export const DEFAULT_MAINTENANCE_RESPONSE: ActiveMaintenanceResponse = {
    isMaintenance: false,
    seqNo: null,
    startDate: null,
    endDate: null,
    msgCode: null,
    msgContent: null,
};
